import React, { useEffect, useRef, useContext, useState, useMemo } from "react";
import PropTypes from "prop-types";
import style from "./VideoGrid.module.sass";
import CallButtons from "../CallButtons/CallButtons";
import { LiveCallsContext } from "../LiveCalls";
import FeedbackButton from "../FeedbackButton/FeedbackButton";

function VideoGrid(props) {
  const {
    translations,
    showRemoteSharedScreen,
    setShowRemoteSharedScreen,
    isRecording,
    onNotAnsweredCall
  } = useContext(LiveCallsContext);
  const [showVideo, setShowVideo] = useState(false);

  const isFirstRender = useRef(true);

  const onClickReload = () => {
    location.reload();
  };

  // Per chiusura chiamata dopo 30 secondi se non arriva il remote
  useEffect(() => {
    setTimeout(function () {
      if (rtc.remoteStreams.length == 0 && $(".text-ended").hasClass("d-none")) {
        onNotAnsweredCall();
        setShowVideo(true);
      }
    }, 30 * 1000);
  }, []);

  // Per definire e impostare le callback su rtc
  useEffect(() => {
    const onOpenRemoteSharedScreen = () => {
      setShowRemoteSharedScreen(rtc.showRemoteSharedScreen);
    };

    const onCloseRemoteSharedScreen = () => {
      setShowRemoteSharedScreen(rtc.showRemoteSharedScreen);
    };

    rtc.onOpenRemoteSharedScreen = onOpenRemoteSharedScreen;
    rtc.onCloseRemoteSharedScreen = onCloseRemoteSharedScreen;

    // Cleanup: rimuovi la funzione al dismount del componente
    return () => {
      rtc.onOpenRemoteSharedScreen = null;
      rtc.onCloseRemoteSharedScreen = null;
    };
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Salta l'esecuzione dell'effetto al mount
    }

    rtc.localVideoTrack.play("local_stream");
    rtc.remoteStreams.filter(
      (stream) => stream.getMediaStreamTrack().kind === 'video'
    ).forEach((stream) => {
      const id = stream.getUserId();
      // remove the view eventually added in agora-client.js
      removeView(id);
      if (showRemoteSharedScreen) {
        // Add the screen and video elements to the corresponding containers
        if (isShareScreen(id)) {
          addView(id, false, 'remote_shared_screen');
        } else {
          addView(id, false, 'remote_video_container');
        }
      } else {
        // Add the video element to the videoGrid container
        // ensuring it is not a screen share
        if (!isShareScreen(id)) addView(id);
      }

      const elementId = "remote_video_" + id;
      const playStream = () => {
        if (document.getElementById(elementId)) {
          stream.play(elementId);
          $('.text-ongoing').addClass('d-none');
        } else {
          setTimeout(playStream, 500); // Retry after a short delay
        }
      };

      setTimeout(playStream, 500);
    });
  }, [showRemoteSharedScreen]);

  const renderP2P = () => {
    return (
      <div className={`${style.VideoGrid}`} id={"videoGrid"}>
        <div className={style.ProfessionalVideoView}>
          <div
            className={`${style.VideoPlaceHolder} video-placeholder`}
            id={"local_stream"}
          ></div>
        </div>
        <div className={style.BackgroundOngoingCall}>
          {!showVideo && (
            <div className={`${style.TextOngoing} text-ongoing no-call-hide`}>
              {translations.onGoing}
            </div>
          )}
          <div className={`${style.TextEnded} text-ended d-none`}>{translations.ended}</div>
          {showVideo && (
            <div className={`${style.TextOngoing} text-ongoing no-call-show`}>
              {translations.noAnswer}
              <div className={"row justify-content-center"}>
                <small className={"col-lg-8"}>
                  <div
                    className={`${style.RecallButton}`}
                    onClick={onClickReload}
                  >
                    {translations.recall}
                  </div>
                </small>
              </div>
            </div>
          )}
        </div>
        {/* The patient's video and screen will be placed here, appended with class="video-view" */}
        <div className={`${style.CallButtons}`}>
          <CallButtons translations={translations.screenShare} />
          {isRecording && (
            <div className={style.FeedbackContainer}>
              <FeedbackButton />
            </div>
          )}
        </div>
      </div>

    )
  }

  const renderWithRemoteSharedScreen = () => {
    return (
      <div className={style.VideoGrid} id={'videoGrid'}>
        <div className={style.RemoteScreen} id={'remote_shared_screen'}>
          {/* The patient's screen will be placed here, appended with class="video-view" */}
        </div>
        <div className={style.UsersContainer}>
          <div className={style.CameraVideoContainer}>
            <div
              className={`${style.VideoPlaceHolder} video-placeholder`}
              id={"local_stream"}
            ></div>
          </div>
          <div className={style.CameraVideoContainer}>
            <div
              className={`${style.VideoPlaceHolder} video-placeholder`}
              id={"remote_video_container"}
            >
              {/* The patient's video will be placed here, appended with class="video-view" */}
            </div>
          </div>
        </div>
        <div className={`${style.CallButtons}`}>
          <CallButtons translations={translations.screenShare} />
          {isRecording && (
            <div className={style.FeedbackContainer}>
              <FeedbackButton />
            </div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div>
      {showRemoteSharedScreen ? renderWithRemoteSharedScreen() : renderP2P()}
    </div>
  );
}

VideoGrid.propTypes = {};

VideoGrid.defaultProps = {};

export default VideoGrid;
